import { render } from "./SideBar.vue?vue&type=template&id=53a37692"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=53a37692&lang=css"

import exportComponent from "/Users/qinzilie/INFURA-UI/infura-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__